import { useTranslation } from "react-i18next";

import { DropdownGlobal, IDropDown } from "../../../../../components/DropdownGlobal";
import { ContainerBody, ContainerInputs } from "../../../StyleCSS/bodyCreateEdit";

interface AccessVideoExpirationProps {
  editedValue: string;
  setEditedValue: (e: any) => void;
  fieldError: boolean;
  selectedAccessVideoExpirationName: string;
}

const listAccessVideoExpirationDays: Array<IDropDown> = [
  { name: "1", id: 1 },
  { name: "2", id: 2 },
  { name: "3", id: 3 },
  { name: "4", id: 4 },
  { name: "5", id: 5 },
  { name: "6", id: 6 },
  { name: "7", id: 7 },
  { name: "10", id: 10 },
  { name: "15", id: 15 },
  { name: "30", id: 30 },
  { name: "60", id: 60 },
];

const AccessVideoExpiration = ({
  editedValue,
  setEditedValue,
  fieldError,
  selectedAccessVideoExpirationName,
}: AccessVideoExpirationProps) => {
  const { t } = useTranslation();
  return (
    <ContainerBody>
      <ContainerInputs>
        <DropdownGlobal
          labelName={t("systemConfiguration.accessExpiration.daysToExpire")}
          options={listAccessVideoExpirationDays}
          error={fieldError}
          setSelected={setEditedValue}
          required={false}
          editDropdown={selectedAccessVideoExpirationName}
          defaultValue={selectedAccessVideoExpirationName}
        />
      </ContainerInputs>
    </ContainerBody>
  );
};

export default AccessVideoExpiration;